import { faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Loading from '../../collection/icons/Loading';
import SignatureCanvas from '../../collection/inputs/SignatureCanvas';
import { apiForm, apiGet, apiUrl, getSession } from '../../utils/api';
import { notify, swalert } from '../../utils/notifications';

export default function Firmar(props) {
    const params = useParams();
    const [data, setData] = useState();
    const [isSaving, setIsSaving] = useState(false);
    const usuario = getSession();

    // update data
    useEffect(() => { updateData(); });
    const updateData = async () => setData(await apiGet("pdfs/get/" + params.idPdf));

    // save sign
    const handleSign = async img => {
        if (img) {
            let formData = new FormData();
            formData.append("signature", img);
            setIsSaving(true);
            if (await apiForm("pdfs/sign/" + params.idPdf, formData)) {
                swalert("Ok", "PDF firmado correctamente", "success");
                updateData();
            }
            setIsSaving(false);
        } else {
            notify("La firma no puede estar en blanco", 'warning');
        }
    }

    // render
    return data ? <>
        <h2>Hoja de fichajes de {data.nombreTrabajador}, mes {moment(data.mes).format("MMMM YYYY")}</h2>
        <a href={apiUrl(`pdfs/view/${params.idPdf}`)}>
            <Button variant={data.firmado ? "success" : "primary"} className="mt-3">
                Ver PDF {data.firmado ? "firmado" : "generado"} <FontAwesomeIcon icon={faFile} />
            </Button>
        </a>
        {(!data.firmado && data.trabajador === usuario.id) && (
            <SignatureCanvas
                width="250" height="150"
                className="mt-3"
                onSign={handleSign}
                isSaving={isSaving} />
        )}
    </> : <Loading />;
}
